export default __webpack_public_path__ + "e1c015a064c239a08946a7b457bff933.png";